// Simple localization helper

const translations = {
  my: {
    // Common
    "Sign in": "အကောင့်ဝင်ရန်",
    "View pricing": "စျေးနှုန်းကြည့်ရန်",
    "Logout": "ထွက်မည်",
    "Profile": "ပရိုဖိုင်",
    "Settings": "ဆက်တင်များ",
    "English": "အင်္ဂလိပ်",
    "Burmese": "မြန်မာ",
    "Language": "ဘာသာစကား",

    // Landing Page
    "Order management that keeps your shop in sync": "သင့်ဆိုင်၏ လုပ်ငန်းစဉ်များကို မြန်ဆန်တိကျစေမည့် အော်ဒါစီမံခန့်ခွဲမှု",
    "Order Master helps teams move faster from sale to fulfillment with clean workflows, clear roles, and real-time insight.": "Order Master ၏ တိကျမြန်ဆန်သော လုပ်ငန်းအဆင့်ဆင့်၊ တိကျသော တာဝန်သတ်မှတ်ချက်များနှင့် အချိန်နှင့်တစ်ပြေးညီ အချက်အလက်များက သင့်ဆိုင်ကို အရောင်းမှသည် ပစ္စည်းပေးပို့မှုအထိ ပိုမိုမြန်ဆန်စေပါသည်။",
    "Order Master": "Order Master",
    "Quick overview": "အနှစ်ချုပ် ကြည့်ရှုရန်",
    "Product screenshots": "ဆော့ဖ်ဝဲလ်မျက်နှာပြင်ပုံများ",
    "Orders": "အော်ဒါများ",
    "Roles": "တာဝန်အခန်းကဏ္ဍ",
    "Orders screen": "အော်ဒါ မျက်နှာပြင်",
    "Inventory screen": "ကုန်ပစ္စည်းလက်ကျန် မျက်နှာပြင်",
    "Reports screen": "အစီရင်ခံစာ မျက်နှာပြင်",
    "Team access screen": "အသင်းဝင် လုပ်ပိုင်ခွင့် မျက်နှာပြင်",
    "Features": "လုပ်ဆောင်ချက်များ",
    "Pricing": "စျေးနှုန်းအစီအစဉ်များ",
    "Fast Order Flow": "လျင်မြန်သော အော်ဒါစီမံမှုစနစ်",
    "Create, manage, and release orders with minimal steps and clear status tracking.": "အဆင့်နည်းနည်းဖြင့် အော်ဒါများကို ဖန်တီး၊ စီမံခန့်ခွဲ၊ ဖြန့်ချိနိုင်ပြီး အခြေအနေကို ရှင်းလင်းစွာ စောင့်ကြည့်နိုင်ပါသည်။",
    "Inventory Confidence": "တိကျသေချာသော ကုန်ပစ္စည်းစာရင်း",
    "Track stock and products in one place so your team never sells what is not available.": "စတော့နှင့် ထုတ်ကုန်များကို တစ်နေရာတည်းမှာ စောင့်ကြည့်နိုင်သောကြောင့် မရှိသောပစ္စည်းများကို မရောင်းမိစေပါ။",
    "Role-Based Access": "တာဝန်အလိုက် အသုံးပြုနိုင်မှု",
    "Give owners, managers, and cashiers the right tools without exposing sensitive settings.": "ပိုင်ရှင်၊ မန်နေဂျာ၊ စာရင်းကိုင်အား လိုအပ်သည့် ခွင့်ပြုချက်များကို ပေးပြီး လုပ်ပိုင်ခွင့်ကန့်သတ်နိုင်ပါသည်။",
    "Sales Visibility": "ရောင်းအား အခြေအနေကို ကြည့်ရှုနိုင်မှု",
    "See sales, reports, and performance at a glance to keep decisions data driven.": "ရောင်းအား၊ အစီရင်ခံစာများနှင့် စွမ်းဆောင်ရည်ကို ပုံမှန်ကြည့်ရှု၍ အချက်အလက်အခြေပြု ဆုံးဖြတ်ချက်များ ချနိုင်ပါသည်။",
    "Order flow": "အော်ဒါ လုပ်ငန်းစဉ်",
    "Create, track, and release orders with confidence.": "အော်ဒါများကို ယုံကြည်စိတ်ချစွာ ဖန်တီးခြင်း၊ စောင့်ကြည့်ခြင်းနှင့် ထုတ်ပေးခြင်းများ ပြုလုပ်ပါ။",
    "Inventory": "ကုန်ပစ္စည်းလက်ကျန်",
    "Stay ahead of stock changes and avoid surprises.": "ကုန်ပစ္စည်းလက်ကျန် အပြောင်းအလဲများကို ကြိုတင်သိရှိပြီး မလိုလားအပ်သော အခက်အခဲများကို ရှောင်ရှားပါ။",
    "Reporting": "အစီရင်ခံစာများ",
    "Daily visibility into sales and performance.": "ရောင်းအားနှင့် လုပ်ငန်းစွမ်းဆောင်ရည်ကို နေ့စဉ် အလွယ်တကူ ကြည့်ရှုနိုင်ပါသည်။",
    "FAQ": "မေးခွန်းနှင့် အဖြေများ",
    "How do I sign in?": "အကောင့်သို့ မည်သို့ဝင်ရောက်ရမည်နည်း?",
    "Use your email and password on the sign in screen. Google sign in is also available.": "အကောင့်ဝင်သည့်စာမျက်နှာတွင် အီးမေးလ်နှင့် စကားဝှက်ကို အသုံးပြုပါ။ Google ဖြင့်လည်း အကောင့်ဝင်နိုင်ပါသည်။",
    "Can I manage multiple staff roles?": "၀န်ထမ်းအခန်းကဏ္ဍများကို စီမံခန့်ခွဲနိုင်ပါသလား?",
    "Yes. Owners, managers, operators, and cashiers can be assigned different access levels.": "ပိုင်ရှင်၊ မန်နေဂျာ၊ အော်ပရေတာနှင့် စာရင်းကိုင်အကောင့်များဖြင့် ခွဲခြားအသုံးပြုနိုင်ပါသည်။",
    "How many reports are available?": "အစီရင်ခံစာ အမျိုးအစား မည်မျှ ရရှိနိုင်သနည်း?",
    "You can view daily income report, financial report, order report, end of day report, shift report and customer analysis report.": "နေ့စဉ်ဝင်ငွေ၊ ငွေကြေးဆိုင်ရာသုံးသပ်ချက်၊ အော်ဒါအခြေအနေ၊ အလှည့်ကျတာဝန် (Shift) နှင့် ဖောက်သည်သုံးသပ်ချက် အစီရင်ခံစာများကို ကြည့်ရှုနိုင်ပါသည်။",
    "Order Master. Built for busy teams.": "Order Master - အော်ဒါလက်ခံသော စီးပွားရေးလုပ်ငန်းများအတွက် အထူးထုတ်လုပ်ထားသည်။",

    // Pricing
    "Trial": "စမ်းသပ်အသုံးပြုမှု",
    "Free": "အခမဲ့",
    "Start with free 100 credits.": "အခမဲ့ Credit ၁၀၀ ဖြင့် စတင်လိုက်ပါ။",
    "Premium": "ပရီမီယမ်",
    "1 Credit = 100 Kyat": "1 Credit = ၁၀၀ ကျပ်",
    "After enjoying trial mode": "စမ်းသပ်အသုံးပြုမှုကို ကျေနပ်အားရပြီးနောက်",
    "Enterprise": "လုပ်ငန်းကြီးများအတွက်",
    "Custom": "ညှိနှိုင်းဈေးနှုန်း",
    "Multi-branch operations and tailored support.": "ဆိုင်ခွဲများစွာရှိသောလုပ်ငန်းများအတွက် အထူးပံ့ပိုးကူညီမှုစနစ်။",
    "Core order flow": "အဓိက အော်ဒါ လုပ်ငန်းစဉ်",
    "Stock tracking": "ကုန်ပစ္စည်းလက်ကျန် စောင့်ကြည့်စစ်ဆေးမှု",
    "Role-based access": "တာဝန်အလိုက် အသုံးပြုနိုင်မှု",
    "Promotion tools": "ပရိုမိုးရှင်း အရောင်းမြှင့်တင်ရေး ကိရိယာများ",
    "Full reports": "ပြည့်စုံသော အစီရင်ခံစာများ",
    "All basic features": "အခြေခံ အင်္ဂါရပ်များအားလုံး",
    "Multi-shop setup": "ဆိုင်များစွာအသုံးပြုနိုင်",
    "Priority support": "ဦးစားပေး အကူအညီ",
    "Custom workflows": "လုပ်ငန်းလိုအပ်ချက်အလိုက် ပြုပြင်ပေးမှု",

    // Login
    "Continue with Google": "Google ဖြင့် ဆက်လက်ပါ။",
    "or": "သို့မဟုတ်",
    "Email": "အီးမေးလ်",
    "Password": "စကားဝှက်",
    "Login": "ဝင်ရောက်ရန်",
    "Forgot Password?": "စကားဝှက်မေ့သွားပါသလား?",

    // Customer Report
    "Customer Dashboard": "ဖောက်သည် ဒက်ရှ်ဘုတ်",
    "Filter": "စစ်ထုတ်ရန်",
    "This Month": "ယခုလ",
    "This Year": "ယခုနှစ်",
    "Within Two Years": "နှစ်နှစ်အတွင်း",
    "New Customer Sign-ups Over Time": "ဖောက်သည်အားလုံး",
    "New Customer Sign-ups (Per Month)": "လစဉ်ဖောက်သည်အသစ်များ",
    "Month": "လ",
    "New Customers": "ဖောက်သည်အသစ်များ",
    "Top 10 Customers by Orders": "အော်ဒါအရေအတွက်အများဆုံး ဖောက်သည် ၁၀ ဦး",
    "Number of Orders per Customer": "ဖောက်သည်တစ်ဦးလျှင် အော်ဒါအရေအတွက်",
    "Number of Orders": "အော်ဒါအရေအတွက်",
    "Customer Name": "ဖောက်သည်အမည်",
    "Customer Type": "ဖောက်သည်အမျိုးအစား",
    "One-time": "တစ်ကြိမ်",
    "Repeat": "အကြိမ်ကြိမ်",
    "Customer Frequency Distribution": "ဖောက်သည်မှာယူမှုအကြိမ်ခွဲဝေမှု",
    "Distribution of Customers by Frequency": "မှာယူမှုအကြိမ်အရေအတွက်ပေါ်မူတည်၍ ဖောက်သည်ခွဲဝေမှု",
    "Customer Data Table": "ဖောက်သည်အချက်အလက် ဇယား",
    "Phone Number": "ဖုန်းနံပါတ်",
    "Order ID": "အော်ဒါအမှတ်",
    "Order Date": "အော်ဒါနေ့စွဲ",
    "Order Density": "အော်ဒါအရေအတွက်",

    // Financial Report
    "Financial Report": "ငွေကြေးအစီရင်ခံစာ",
    "From Date": "မှ နေ့စွဲ",
    "To Date": "သို့ နေ့စွဲ",
    "Income by Payment Method": "ငွေပေးချေမှုနည်းလမ်းအလိုက် ဝင်ငွေ",
    "Total Transaction by Date": "နေ့စွဲအလိုက် စုစုပေါင်းဝင်ငွေ",
    "Total Balance by Date": "နေ့စွဲအလိုက် စုစုပေါင်း လက်ကျန်ငွေ",
    "Total Amount by Category": "အမျိုးအစားအလိုက် စုစုပေါင်း ပမာဏ",
    "Category": "အမျိုးအစား",
    "Total Amount": "စုစုပေါင်း ပမာဏ",
    "Payment Method": "ငွေပေးချေမှုနည်းလမ်း",
    "Amount": "ပမာဏ",
    "Date": "နေ့စွဲ",
    "Income": "ဝင်ငွေ",
    "Outcome": "ထွက်ငွေ",
    "Refund": "ပြန်အမ်းငွေ",
    "Balance": "လက်ကျန်ငွေ",
    "Description": "ဖော်ပြချက်",
    "In/Out": "ဝင်/ထွက်",
    "Total": "စုစုပေါင်း",
    "In": "ဝင်",
    "Int": "အလယ်အလတ်",
    "Out": "ထွက်",

    // Daily Income Report
    "Daily Income Report": "နေ့စဉ် ဝင်ငွေအစီရင်ခံစာ",
    "ID": "အမှတ်",
    "Income Transactions": "ဝင်ငွေ မှတ်တမ်းများ",
    "Expense Transactions": "ထွက်ငွေ မှတ်တမ်းများ",
    "Cash": "ငွေသား",
    "Kpay": "K Pay",
    "Wave Pay": "Wave Pay",

    // Order Report
    "Order Report": "အော်ဒါ အစီရင်ခံစာ",
    "Total Orders": "စုစုပေါင်း အော်ဒါများ",
    "Order Items": "အော်ဒါ ပစ္စည်းများ",
    "Order Items Quantity": "အော်ဒါ ပစ္စည်းများ အရေအတွက်",
    "Order Details": "အော်ဒါ အသေးစိတ်များ",
    "Item List": "ပစ္စည်းစာရင်း",
    "User": "အသုံးပြုသူ",
    "Order Count": "အော်ဒါအရေအတွက်",
    "Item": "ပစ္စည်း",
    "Quantity": "အရေအတွက်",

    // Shift Report
    "noShiftDataMessage": "ရွေးချယ်ထားသော နေ့စွဲအပိုင်းအခြားအတွက် အလုပ်အပိုင်းအခြား အချက်အလက်များ မရှိပါ။ နေ့စွဲစစ်ထုတ်မှုများကို ပြောင်းလဲကြည့်ပါ သို့မဟုတ် နောက်မှ စစ်ဆေးကြည့်ပါ။",
    "amountByUser": "အသုံးပြုသူအလိုက် ပမာဏ",
    "amount": "ပမာဏ",
    "userName": "အသုံးပြုသူအမည်",
    "sr": "စဉ်",
    "shiftStartTime": "အလုပ်စတင်ချိန်",
    "shiftEndTime": "အလုပ်ပြီးဆုံးချိန်",
    "openingCash": "အဖွင့်ငွေသား",
    "cashPayment": "ငွေသားပေးချေမှု",
    "refund": "ပြန်အမ်းငွေ",
    "paidIn": "ပေးသွင်းငွေ",
    "paidOut": "ထုတ်ယူငွေ",
    "balance": "လက်ကျန်ငွေ",
    "from": "မှ",
    "to": "သို့",

    "Please enter both email and password.": "အီးမေးလ်နှင့် စကားဝှက်နှစ်ခုစလုံး ထည့်သွင်းပါ။",
    "Invalid email or password.": "အီးမေးလ် သို့မဟုတ် စကားဝှက် မမှန်ပါ။",
    "Google sign-in failed.": "Google အကောင့်ဝင်ခြင်း မအောင်မြင်ပါ။",
    "Turnstile verification error. Please try again.": "Turnstile စစ်ဆေးမှု အမှားဖြစ်ပေါ်သည်။ ထပ်မံ ကြိုးစားပါ။",

    // Forgot Password
    "Forgot Password": "စကားဝှက် မေ့သွားပါသည်",
    "Email Address": "အီးမေးလ် လိပ်စာ",
    "Reset Password": "စကားဝှက် ပြန်လည် သတ်မှတ်ရန်",
    "Password reset email sent. Check your inbox.": "စကားဝှက် ပြန်လည်သတ်မှတ်ရန် အီးမေးလ် အတည်ပြုပေးပြီးပါပြီ။ inbox ကို စစ်ဆေးပါ။",
    "Error sending password reset email. Please try again.": "စကားဝှက် ပြန်လည်သတ်မှတ်ရန် အီးမေးလ် ပို့ပေးရာတွင် အမှား ဖြစ်ပွားသည်။ ထပ်မံ ကြိုးစားပါ။",

    // Unauthorized
    "Unauthorized Access": "ခွင့်ပြုမထားသော ဝင်ရောက်မှု",
    "You do not have permission to access this page.": "ဤ စာမျက်နှာသို့ ဝင်ရောက်ရန် ခွင့်မပြုပါ။",
    "Go Back": "ပြန်သွားရန်",

    // Layout / Sidebar
    "New Sale": "ကုန်ရောင်းရန်",
    "View Sales": "ကုန်ရောင်းစာရင်းများ",
    "New Order": "အော်ဒါအသစ်",
    "View Orders": "အော်ဒါများ ကြည့်ရှုရန်",
    "Manage Orders": "အော်ဒါများ စီမံခန့်ခွဲရန်",
    "View Stock": "စတော့ခ် ကြည့်ရှုရန်",
    "Daily Report": "နေ့စဉ်အစီရင်ခံစာ",
    "Manage Stock": "စတော့ခ် စီမံရန်",
    "Release Orders": "အော်ဒါထုတ်ယူခြင်း",
    "Products": "ထုတ်ကုန်များ",
    "Promotion Codes": "ကြော်ငြာကုဒ်များ",
    "Reports": "အစီရင်ခံစာများ",
    "Users": "အသုံးပြုသူများ",
    "Start Shift": "အလုပ်စတင်ရန်",
    "End Shift": "အလုပ်နားရန်",
    "Credits": "ခရက်ဒစ်",

    // Shift
    "Open Shift": "အလုပ်စတင်ရန်",
    "Opening Cash Amount": "အဖွင့် ငွေပမာဏ",
    "End Day": "ဆိုင်ပိတ်မည်",
    "Loading overdue orders...": "နောက်ကျသော အော်ဒါများကို ရယူနေသည်...",
    "Accept and End Day": "ဆိုင်ပိတ်ရန်အတည်ပြုသည်",
    "Print End of Day Report": "အစီရင်ခံစာ ပုံနှိပ်ရန်",
    "Actual Cash Amount": "အမှန်တကယ် ငွေပမာဏ",
    "Close Shift": "အလုပ်နားရန်",
    "Date & Time": "နေ့စွဲနှင့် အချိန်",
    "No shift data available.": "အလုပ်ဂျူတီ အချက်အလက် မရှိပါ။",
    "Shift Report": "အလုပ်ဂျူတီ အစီရင်ခံစာ",
    "Shift ID": "အလုပ်အမှတ်",
    "Shift Start Time": "အလုပ် စတင်ချိန်",
    "Shift End Time": "အလုပ် ပြီးဆုံးချိန်",
    "User Name": "အသုံးပြုသူ အမည်",
    "Starting Cash": "အဖွင့် ငွေသား",
    "Cash Payments": "ငွေသားပေးချေမှု",
    "Refunds": "ပြန်အမ်းငွေများ",
    "Paid In": "ပေးသွင်းငွေ",
    "Paid Out": "ထုတ်ယူငွေ",
    "Expected Cash": "မျှော်မှန်း ငွေသား",
    "Actual Cash": "အမှန်တကယ် ငွေသား",
    "Cash Difference": "ငွေသား ကွာဟမှု",
    "Invalid date": "မမှန်ကန်သော နေ့စွဲ",
    "Please enter a valid number": "မှန်ကန်သော နံပါတ်ကို ထည့်သွင်းပါ။",
    "Cash amount cannot be negative": "ငွေပမာဏသည် အနုတ် မဖြစ်ရပါ။",
    "Actual cash amount cannot be zero": "အမှန်တကယ် ငွေပမာဏသည် သုည မဖြစ်ရပါ။",

    // Generic
    "Continue": "ဆက်လက်ရန်",
    "Submit": "တင်ပြရန်",
    "Cancel": "ဖျက်သိမ်းရန်",
    "Back": "နောက်သို့",

    // Category Management
    "Category Management": "အုပ်စုစီမံခန့်ခွဲမှု",
    "Add Category": "အုပ်စုထည့်ရန်",
    "Edit Category": "အုပ်စုပြင်ရန်",
    "Category Name": "အုပ်စုအမည်",
    "Actions": "လုပ်ဆောင်ချက်များ",
    "Failed to load categories. Please try again.": "အုပ်စုအမည်ကို မဖော်ပြနိုင်ပါ။ ထပ်မံကြိုးစားပါ။",
    "Failed to save the category. Please try again.": "အုပ်စုကိုသိမ်းဆည်းမှု မအောင်မြင်ပါ။ ထပ်မံ ကြိုးစားပါ။",
    "Failed to delete the category. Please try again.": "အုပ်စုအမည်ကို ဖျက်ရန် မအောင်မြင်ပါ။ ထပ်မံ ကြိုးစားပါ။",

    // User Management
    "User Management": "အသုံးပြုသူ စီမံခန့်ခွဲမှု",
    "Add Employee": "၀န်ထမ်းထည့်ရန်",
    "Edit Employee": "၀န်ထမ်း တည်းဖြတ်ရန်",
    "Add New Employee": "၀န်ထမ်းအသစ် ထည့်ရန်",
    "Name": "အမည်",
    "Phone": "ဖုန်း",
    "Username": "အသုံးပြုသူအမည်",
    "Confirm Password": "စကားဝှက် အတည်ပြုရန်",
    "Role": "အခန်းကဏ္ဍ",
    "Manager": "မန်နေဂျာ",
    "Cashier": "စာရင်းကိုင်",
    "Operator": "အော်ပရေတာ",
    "Username already taken!": "အသုံးပြုသူအမည် ရှိပြီးသားဖြစ်နေသည်။",
    "Passwords do not match!": "စကားဝှက်များ မကိုက်ညီပါ။",
    "Employee updated successfully!": "၀န်ထမ်းအချက်အလက် အောင်မြင်စွာ ပြုပြင်ပြီးပါပြီ!",
    "Employee added successfully!": "၀န်ထမ်း အသစ် ထည့်သွင်းပြီးပါပြီ!",
    "Error saving employee. Please try again.": "၀န်ထမ်းကို သိမ်းဆည်းရခြင်းတွင် မှားယွင်းမှု ဖြစ်ခဲ့သည်။ ထပ်မံ ကြိုးစားပါ။",
    "Employee deleted successfully!": "၀န်ထမ်းကို အောင်မြင်စွာ ဖျက်ပြီးပါပြီ!",
    "Error deleting employee. Please try again.": "၀န်ထမ်းကို ဖျက်ရာတွင် အမှား ဖြစ်သွားသည်။ ထပ်မံ ကြိုးစားပါ။",

    // Refund
    "This order has already been refunded. Multiple refunds are not allowed.": "ဤအော်ဒါအတွက် အရင်တစ်ကြိမ် ပြန်လည်ပေးခဲ့ပြီးဖြစ်သည်။ ထပ်မံ၍ ပြန်လည်ပေးခြင်းများကို ခွင့်မပြုပါ။",
    "Refund amount must be between 0 and {max} MMK": "ပြန်အမ်းသင့်သော ငွေပမာဏသည် 0 နှင့် {max} MMK အကြား ဖြစ်ရမည်။",
    "Error processing refund: {message}": "ပြန်အမ်းခြင်းကို လုပ်ဆောင်ရာတွင် အမှားဖြစ်နေသည်: {message}",
    "No valid refund details available for printing": "ပုံနှိပ်ရန် သက်ဆိုင်ရာ ပြန်အမ်းခြင်း အသေးစိတ် မရှိပါ။",
    "Error printing refund slip": "ပြန်အမ်း စလစ်ကို ပုံနှိပ်ရာတွင် အမှား ဖြစ်ပွားသည်။",
    "Refund Order": "ပြန်အမ်းခွင့်",
    "Available Refund Amount": "လက်ကျန် ပြန်အမ်းနိုင်သော ငွေပမာဏ",
    "Maximum refund is {max} MMK": "အများဆုံး ပြန်အမ်းနိုင်သည့် ငွေမှာ {max} MMK ဖြစ်သည်",
    "Refund History": "ပြန်အမ်းခြင်း မှတ်တမ်း",
    "Amount (MMK)": "ပမာဏ (MMK)",
    "Reason": "အကြောင်းပြချက်",
    "No refund history available for this order.": "ဤအော်ဒါအတွက် ပြန်အမ်းခြင်း မှတ်တမ်း မရှိပါ။",
    "Processing...": "လုပ်ဆောင်နေသည်...",
    "Save": "သိမ်းရန်",
    "Categories": "အမျိုးအစားများ",
    "Failed to load data.": "ဒေတာ ရယူ၍ မရပါ။",
    "Refund Amount": "ပြန်အမ်းငွေ ပမာဏ",
    "Refund Reason": "ပြန်အမ်းသည့်အကြောင်းရင်း",
    "Delivery Charge": "သယ်ယူပို့ဆောင်ခ",
    "New Order Report": "အော်ဒါအသစ် အစီရင်ခံစာ",
    "Overdue Order Report": "နောက်ကျ အော်ဒါ အစီရင်ခံစာ",
    "End of Day Report": "နေ့ချုပ် အစီရင်ခံစာ",
    "Customer Report": "ဖောက်သည် အစီရင်ခံစာ",
    "Subtotal": "စုစုပေါင်းငွေ (အခွန်မပါ)",
    "Tax": "အခွန်",
    "Stock Management": "စတော့ စီမံခန့်ခွဲမှု",
    "Manage Stock for {name}": "{name} အတွက် စတော့ စီမံခန့်ခွဲမှု",
    "Total Stock": "စုစုပေါင်း စတော့",
    "Existing Payments": "ရှိပြီးသား ငွေပေးချေမှုများ",
    "New Payments": "အသစ် ထည့်သွင်းသည့် ငွေပေးချေမှုများ",
    "Please select a variant.": "မျိုးကွဲတစ်ခု ရွေးပါ။",
    "Number of Customers": "ဖောက်သည် အရေအတွက်",
    "Expense": "ထွက်ငွေ",
    "Print": "ပုံနှိပ်ရန်",
    "Close": "ပိတ်ရန်",

    // New Order
    "You are offline. Some features may not be available.": "သင် အော့ဖ်လိုင်း ဖြစ်နေသည်။ အချို့ အင်္ဂါရပ်များကို အသုံးမပြုနိုင်ပါ။",
    "You are not on shift. Please start your shift to proceed.": "သင့် အလုပ်မစတင်သေးပါ။ ဆက်လက်လုပ်ဆောင်ရန် မီနူးဘားရှိ အလုပ်စတင်ပါ ကိုနှိပ်ပါ။",
    "Insufficient credit. Please add funds to proceed.": "ခရက်ဒစ် မလုံလောက်ပါ။ ဆက်လက်လုပ်ဆောင်ရန် ခရက်ဒစ်ထည့်ပါ။",
    "Error creating order": "အော်ဒါ ဖန်တီးရာတွင် အမှား ဖြစ်ပွားသည်။",
    "Order created successfully, 1 credit deducted.": "အော်ဒါကို အောင်မြင်စွာ ဖန်တီးပြီး ခရက်ဒစ်တစ်ခု နုတ်ပြီးပါပြီ။",

    // Release Orders
    "From": "မှ",
    "To": "သို့",
    "Search": "ရှာဖွေမည်",
    "Show only Uncompleted Orders": "မပြီးသေးသောအော်ဒါများကိုသာ ပြပါ",
    "Status": "အခြေအနေ",
    "Fulfillment Date": "ရက်ချိန်းနေ့စွဲ",
    "Fulfillment Method": "ယူမည့်နည်းလမ်း",
    "Action": "လုပ်ဆောင်ချက်",
    "Order was already marked as completed": "အော်ဒါကို အပြီးသတ်ထားသည်အဖြစ် အမှတ်အသားထားပြီးသည်",
    "Order not found": "အော်ဒါမတွေ့ပါ",
    "Balance already collected for this order": "အော်ဒါအတွက် ကျန်ငွေကို ယခင်က ရယူပြီးပါပြီ",
    "Avoided duplicate transaction entry": "ထပ်တူညီသော မှတ်တမ်းကို ရှောင်ကြဉ်ထားသည်။",
    "Delivery fee already paid for this order": "ဤအော်ဒါအတွက် သယ်ယူပို့ဆောင်ခကို ပေးချေပြီးဖြစ်ပါသည်",
    "Cannot refund: Order must be in 'Unfulfilled' status": "ပြန်အမ်း၍ မရပါ: အော်ဒါသည် 'မပြီးစီးသေး' အခြေအနေတွင်ရှိရပါမည်",
    "Refund processed successfully": "ပြန်အမ်းခြင်းကို အောင်မြင်စွာ ဆောင်ရွက်ပြီးပါပြီ",

    // View Orders
    "Active Orders": "လက်ရှိ အော်ဒါများ",
    "Canceled Orders": "ပယ်ဖျက်ထားသော အော်ဒါများ",
    "Order canceled successfully.": "အော်ဒါကို အောင်မြင်စွာ ပယ်ဖျက်ပြီးသည်။",
    "Order status is not 'Unfulfilled', so it cannot be canceled.": "အော်ဒါအခြေအနေသည် 'မပြီးစီးသေး' အခြေအနေဖြစ်သည်၊ ထို့ကြောင့် ပယ်ဖျက်၍ မရပါ။",
    "Error updating order status or deleting cashbook entry.": "အော်ဒါအခြေအနေကို အပ်ဒိတ်လုပ်ခြင်း သို့မဟုတ် ငွေစာရင်း မှတ်တမ်းကို ဖျက်ခြင်းတွင် အမှား ဖြစ်ခဲ့သည်။",
    "Confirm Deletion": "ဖျက်ရန် အတည်ပြုပါ",
    "Are you sure you want to cancel order {orderId}?": "သင် အော်ဒါ {orderId} ကို ပယ်ဖျက်ချင်ပါသလား?",
    "Order not found.": "အော်ဒါ မတွေ့ပါ။",
    "Confirm": "အတည်ပြုရန်",
    "Canceled": "ပယ်ဖျက်ပြီး",
    "Loading...": "လုပ်ဆောင်နေသည်...",
    "This Order is Already Completed": "ဤအော်ဒါသည် ပြီးဆုံးပြီး ဖြစ်ပါသည်",
    "Outstanding Balance": "ကျန်ရှိငွေ",
    "Please ensure split payments total matches the balance.": "ခွဲခြားပေးချေမှု စုစုပေါင်းပမာဏသည် လက်ကျန်နှင့် ကိုက်ညီကြောင်း သေချာပါစေ။",
    "Collect Balance": "လက်ကျန် ရယူရန်",
    "Print Receipt": "ပြေစာ ပုံနှိပ်ရန်",
    "Pay Delivery": "သယ်ယူခ ပေးရန်",
    "Complete Order": "အော်ဒါ ပြီးဆုံးရန်",

    // Additional UI
    "All": "အားလုံး",
    "Unknown": "မသိ",
    "Fulfilled": "ပြီးစီးပြီး",
    "Unfulfilled": "မပြီးစီးသေး",
    "Completed": "ရွေးယူပြီး",
    "Order": "အော်ဒါ",
    "Item Name": "ပစ္စည်းအမည်",
    "Variant": "မျိုးကွဲ",
    "Inscription Text": "စာသားအညွှန်း",
    "Order Notes": "အော်ဒါမှတ်ချက်",
    "Images": "ပုံများ",
    "No images available": "ပုံများ မရှိပါ။",
    "Today Orders": "ယနေ့ အော်ဒါများ",
    "Tomorrow Orders": "မနက်ဖြန် အော်ဒါများ",
    "Total Orders in Week": "တစ်ပတ်အတွင်း အော်ဒါစုစုပေါင်း",
    "Fulfilled Orders": "ပြီးစီးပြီး အော်ဒါများ",
    "Unfulfilled Orders": "မပြီးစီးသေးသော အော်ဒါများ",
    "Order ID, Inscription etc.": "အော်ဒါအမှတ်၊ စာသား စသည်",
    "No inscription": "စာသား မရှိပါ",
    "Inscription":"စာသားအညွှန်း",
    "Walk-in": "လမ်းလျှောက်ဖောက်သည်",
    "N/A": "မရှိပါ",
    "Notes": "မှတ်ချက်များ",
    "No notes": "မှတ်ချက် မရှိပါ",
    "Customer": "ဖောက်သည်",
    "Fulfillment":"လုပ်ဆောင်မှု",
    "Complete": "ပြီးစီးရန်",
    "Details": "အသေးစိတ်",
    "New orders have arrived!": "အော်ဒါအသစ်များ ရောက်ရှိလာပါပြီ!",
    "Confirm order completion?": "အော်ဒါပြီးစီးမှုကို အတည်ပြုပါသလား?",
    "Yes": "ဟုတ်ကဲ့",
    "No": "မဟုတ်ပါ",
    "Delivery Charge Method": "ပို့ခပုံစံ",
    "Advance": "ကြိုတင်",
    "To Collect": "ကောက်ခံရန်",
    "Collected Balance": "ကောက်ခံပြီး လက်ကျန်",
    "Collected Time": "ကောက်ခံချိန်",
    "Fulfillment Time": "ရက်ချိန်း",
    "Released By": "ထုတ်ပေးသူ",
    "Delivery Address": "ပို့ဆောင်ရန်လိပ်စာ",
    "Orders to be Taken Today": "ယနေ့ ယူရမည့် အော်ဒါများ",
    "Orders to be Taken Tomorrow": "မနက်ဖြန် ယူရမည့် အော်ဒါများ",
    "Today Orders to Deliver": "ယနေ့ ပို့ဆောင်ရမည့် အော်ဒါများ",
    "Avoided duplicate delivery payment entry": "ထပ်တူ သယ်ယူခ မှတ်တမ်းကို ရှောင်ရှားခဲ့သည်",
    "Search Products": "ထုတ်ကုန်များ ရှာရန်",
    "Search Stock": "စတော့ ရှာရန်",
    "Product Management": "ထုတ်ကုန် စီမံခန့်ခွဲမှု",
    "Stock Overview": "စတော့ အနှစ်ချုပ်",
    "Last Updated": "နောက်ဆုံး ပြင်ဆင်ချိန်",
    "Total Added": "စုစုပေါင်း ထည့်သွင်းထား",
    "Total Sold": "စုစုပေါင်း ရောင်းချထား",
    "In Stock": "စတော့ရှိ",
    "Sold": "ရောင်းပြီး",
    "Add Product": "ထုတ်ကုန် ထည့်ရန်",
    "Copy from Master": "နမူနာ ကူးယူရန်",
    "Item Type": "ပစ္စည်းအမျိုးအစား",
    "Variations": "မျိုးကွဲများ",
    "Base Price": "အခြေခံဈေး",
    "None": "မရှိ",
    "Product": "ထုတ်ကုန်",
    "Unnamed Product": "အမည်မဲ့ ထုတ်ကုန်",
    "Uncategorized": "အမျိုးအစားမသတ်မှတ်",
    "Variants": "မျိုးကွဲများ",
    "Hide Details": "အသေးစိတ် ပိတ်ရန်",
    "View Details": "အသေးစိတ် ကြည့်ရန်",
    "Price": "ဈေးနှုန်း",
    "No variants configured.": "မျိုးကွဲ မသတ်မှတ်ထားပါ။",
    "Edit Product": "ထုတ်ကုန် ပြင်ရန်",
    "Product Name": "ထုတ်ကုန် အမည်",
    "Product Type": "ထုတ်ကုန် အမျိုးအစား",
    "Sale": "ရောင်းချ",
    "Inscription Available": "စာသား ပါဝင်နိုင်သည်",
    "Variant Name": "မျိုးကွဲအမည်",
    "Variant Price": "မျိုးကွဲဈေး",
    "New Variant Name": "မျိုးကွဲအသစ် အမည်",
    "New Variant Price": "မျိုးကွဲအသစ် ဈေး",
    "Add Variant": "မျိုးကွဲ ထည့်ရန်",
    "Manage Promotion Codes": "ကြော်ငြာကုဒ် စီမံရန်",
    "Promotion Code Title": "ပရိုမိုးရှင်း ကုဒ် ခေါင်းစဉ်",
    "Start Date": "စတင်နေ့",
    "End Date": "ပြီးဆုံးနေ့",
    "Discount Type": "လျှော့ဈေးအမျိုးအစား",
    "Percentage": "ရာခိုင်နှုန်း",
    "Amount Value": "ပမာဏတန်ဖိုး",
    "Update Promotion": "ပရိုမိုးရှင်း အပ်ဒိတ်",
    "Create Promotion": "ပရိုမိုးရှင်း ဖန်တီးရန်",
    "Discount": "လျှော့ဈေး",
    "Edit": "ပြင်ရန်",
    "Delete": "ဖျက်ရန်",
    "Error": "အမှား",
    "No data available": "အချက်အလက် မရှိပါ",
    "Daily Income Summary": "နေ့စဉ်ဝင်ငွေ အနှစ်ချုပ်",
    "Print Time": "ပုံနှိပ်ချိန်",
    "Cash Summary": "ငွေသား အနှစ်ချုပ်",
    "Total Actual Cash": "စုစုပေါင်း အမှန်တကယ် ငွေသား",
    "Income Summary": "ဝင်ငွေ အနှစ်ချုပ်",
    "Today's Sales": "ယနေ့ ရောင်းချမှု",
    "Debt Received": "အကြွေးရငွေ",
    "Order Summary": "အော်ဒါ အနှစ်ချုပ်",
    "Today's Orders": "ယနေ့ အော်ဒါများ",
    "Receivable Balance": "ရရှိမည့် လက်ကျန်ငွေ",
    "Today's Delivered Orders": "ယနေ့ ပို့ပြီး အော်ဒါများ",
    "Received Balance": "ရရှိပြီး လက်ကျန်ငွေ",
    "Sales by Category": "အမျိုးအစားလိုက် အရောင်း",
    "Sales by Item": "ပစ္စည်းလိုက် အရောင်း",
    "Shifts Summary": "အလုပ်ချိန် အနှစ်ချုပ်",
    "Select Period": "အချိန်ကာလ ရွေးပါ",
    "Morning (6:00 AM - 11:59 AM)": "နံနက် (၆:၀၀ - ၁၁:၅၉)",
    "Evening (12:00 PM - 6:00 PM)": "ညနေ (၁၂:၀၀ - ၆:၀၀)",
    "Select Time": "အချိန် ရွေးပါ",
    "Pickup": "လူကိုယ်တိုင်ရွေး",
    "Delivery": "ပို့ဆောင်ပေးရန်",
    "MMK": "ကျပ်",
    "Collect": "ကောက်ခံ",
    "Insert Images": "ပုံများ ထည့်ရန်",
    "Payment Details": "ငွေပေးချေ အသေးစိတ်",
    "Add Payment Method": "ငွေပေးချေ နည်းလမ်း ထည့်ရန်",
    "Total Paid": "ပေးချေပြီး စုစုပေါင်း",
    "Remaining Balance": "ကျန်ရှိ လက်ကျန်",
    "Promotion Code": "ပရိုမိုးရှင်း ကုဒ်",
    "Add": "ထည့်ရန်",
    "Cashier Name": "ဝန်ထမ်းအမည်",
    "Review Order": "အော်ဒါ ပြန်လည်သုံးသပ်ရန်",
    "Cancel Order": "အော်ဒါ ပယ်ဖျက်ရန်",
    "This field is required": "ဤအကွက်သည် မဖြစ်မနေလိုအပ်သည်",
    "At least one payment is required": "အနည်းဆုံး ငွေပေးချေမှု တစ်ခု လိုအပ်သည်",
    "Promotion applied successfully!": "ပရိုမိုးရှင်း အောင်မြင်စွာ အသုံးပြုပြီးပါပြီ!",
    "Invalid promotion code": "ပရိုမိုးရှင်း ကုဒ် မမှန်ပါ",
    "Selected Items": "ရွေးထားသော ပစ္စည်းများ",
    "Order updated successfully": "အော်ဒါ အောင်မြင်စွာ ပြင်ဆင်ပြီးပါပြီ",
    "Error updating order": "အော်ဒါ ပြင်ဆင်ရာတွင် အမှား",
    "No Date": "နေ့စွဲ မရှိပါ",
    "No Time": "အချိန် မရှိပါ",
    "Paid Amount": "ပေးချေသည့် ပမာဏ",
    "Balance Due": "ပေးချေရမည့် လက်ကျန်",
    "Items": "ပစ္စည်းများ",
    "Payments": "ငွေပေးချေမှုများ",
    "Order Tabs": "အော်ဒါများ",
    "Only Unfulfilled orders can be edited": "မပြီးစီးသေးသော အော်ဒါများကိုသာ ပြင်နိုင်သည်",
    "Order Summary Review": "အော်ဒါ အနှစ်ချုပ် သုံးသပ်ချက်",
    "Customer Information": "ဖောက်သည် အချက်အလက်",
    "Address": "လိပ်စာ",
    "Cart Items": "ခြင်းထဲရှိ ပစ္စည်းများ",
    "Financial Summary": "ငွေကြေး အနှစ်ချုပ်",
    "Edit Order": "အော်ဒါ ပြင်ရန်",
    "Confirm Order": "အော်ဒါ အတည်ပြုရန်",
    "Error loading data": "ဒေတာ ဖတ်ရာတွင် အမှားဖြစ်ပေါ်နေသည်",
    "Stock": "ကုန်စတော့",
    "Select Stock": "စတော့ရွေးပါ",
    "No items added to sale": "ရောင်းချရန် ပစ္စည်းမရှိပါ",
    "Stock Code": "စတော့ကုဒ်",
    "Qty": "အရေအတွက်",
    "Confirm Sale": "ရောင်းချမှု အတည်ပြုရန်",
    "Sales Record": "ရောင်းချမှု မှတ်တမ်း",
    "Search by Sale ID": "ရောင်းချမှု အမှတ်ဖြင့် ရှာ",
    "Sale ID": "ရောင်းချမှု အမှတ်",
    "Toggle drawer": "မီနူး ဖွင့်/ပိတ်",
    "Sales Tabs": "ရောင်းချမှု တက်ဘ်များ",
    "Report tabs": "အစီရင်ခံစာ တက်ဘ်များ",
    "Product and category management tabs": "ထုတ်ကုန်နှင့် အမျိုးအစား စီမံခန့်ခွဲမှု တက်ဘ်များ",
    "Payment method": "ငွေပေးချေ နည်းလမ်း",
    "Cashbook data table": "ငွေစာရင်း ဇယား",
    "Select Date": "နေ့စွဲ ရွေးပါ",
    "Print Report": "အစီရင်ခံစာ ပုံနှိပ်ရန်",
    "Shop Information": "ဆိုင် အချက်အလက်",
    "General Settings": "အထွေထွေ ဆက်တင်များ",
    "Sales Tax Rate": "အခွန်နှုန်း",
    "Rate (%)": "နှုန်း (%)",
    "Shift System": "အလုပ်ဆိုင်းစနစ်",
    "Use Shift System": "အလုပ်ဆိုင်းစနစ် သုံးရန်",
    "Cashiers": "စာရင်းကိုင်များ(Cashiers)",
    "Update": "အပ်ဒိတ်",
    "Save All Settings": "ဆက်တင်အားလုံး သိမ်းရန်",
    "Failed to load settings": "ဆက်တင်များ ရယူရာတွင် မအောင်မြင်ပါ",
    "Settings saved successfully!": "ဆက်တင်များ အောင်မြင်စွာ သိမ်းဆည်းပြီးပါပြီ!",
    "Failed to save settings. Please try again.": "ဆက်တင်များ သိမ်းဆည်းရာတွင် မအောင်မြင်ပါ။ ထပ်မံ ကြိုးစားပါ။",
    "Credit Top-Up": "ခရက်ဒစ် ထပ်ဖြည့်ခြင်း",
    "Current Credit": "လက်ရှိ ခရက်ဒစ်",
    "Credit Amount to Purchase": "ဝယ်ယူမည့် ခရက်ဒစ် ပမာဏ",
    "Amount to Pay": "ပေးချေရမည့် ပမာဏ",
    "Add Credit": "ခရက်ဒစ် ထည့်ရန်",
    "Payment Gateway": "ငွေပေးချေမှုနည်းလမ်း",
    "Edit Profile": "ပရိုဖိုင် ပြင်ရန်",
    "Current Stock": "လက်ရှိ စတော့",
    "Stock Movement": "စတော့ လှုပ်ရှားမှု",
    "Date Added": "ထည့်သွင်းနေ့",
    "Sale Date": "ရောင်းချနေ့",
    "Overdue Orders": "နောက်ကျ အော်ဒါများ",
    "Refund Slip": "ပြန်အမ်း စလစ်",
    "Select Cashier": "စာရင်းကိုင်အမည် ရွေးပါ",
    "Delivery Payment Method": "ပို့ခ ပေးချေမှုနည်းလမ်း",
    "Payment Amount": "ငွေပေးချေ ပမာဏ",
    "Remark": "မှတ်ချက်",
    "Logo": "လိုဂို",
    "Shop Name": "ဆိုင် အမည်",
    "Shop Address": "ဆိုင် လိပ်စာ",
    "No stock entries yet.": "စတော့မှတ်တမ်း မရှိသေးပါ။",
    "Generate": "ထုတ်ပေးရန်",
    "Select a product before updating stock.": "စတော့အပ်ဒိတ်မလုပ်မီ ပစ္စည်းကို ရွေးပါ။",
    "Stock Code is required.": "စတော့ကုဒ် လိုအပ်ပါသည်။",
    "Quantity must be greater than 0": "အရေအတွက်သည် 0 ထက် ကြီးရပါမည်။",
    "Stock Code must be unique": "စတော့ကုဒ် အချင်းချင်း မတူညီရပါ။",
    "Failed to save stock": "စတော့ သိမ်းဆည်း၍ မအောင်မြင်ပါ။",
    "Select a product before deleting stock.": "စတော့မဖျက်မီ ပစ္စည်းကို ရွေးပါ။",
    "Failed to delete stock": "စတော့ ဖျက်၍ မအောင်မြင်ပါ။",
    "Shop access not configured.": "ဆိုင်မှ အခွင့်အရေး သတ်မှတ်မထားပါ။",
    "status-filter": "အခြေအနေ စစ်ထုတ်ခြင်း",
    "WavePay": "Wave Pay",
    "KPay": "K-Pay",
    "Accept Order": "အော်ဒါလက်ခံမည်",
    "Have":"ရှိ",
    "Havenot":"မရှိ",
    "N/A":"မလို"
  }
};

export const translate = (lang, key, vars = {}) => {
  if (!key) return '';
  if (lang === 'en') return key;
  const dict = translations[lang] || {};
  let value = dict[key] || key;

  // interpolate variables like {name}
  Object.keys(vars).forEach((varName) => {
    value = value.replace(new RegExp(`\\{${varName}\\}`, 'g'), vars[varName]);
  });

  return value;
};
